module.exports = __webpack_public_path__ + "img/wcc.8b6cd4b8.png";